import { GET_LEADS_FIELDS, GET_LEADS_FIELDS_ERR } from '../../actionTypes/leadsType'
import { getLeadsFieldsApi } from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'
export const getLeadsFields = (payload) => async (dispatch) => {
    try {
        let results = await axios.get(`${getLeadsFieldsApi}/${payload}`, await accessToken())
        let data = results && results.data
        console.log('GET Leads Fields', data)
        dispatch({
            type: GET_LEADS_FIELDS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_LEADS_FIELDS_ERR,
            payload: error.response,
        });
    }
};


